<template>
  <with-actions>
    <div class="form-inline ml-auto" slot="context-actions" v-if="can('write_customers')">
      <button class="btn btn-primary" @click="create">{{ 'create' | t }} {{ payment.doc_type | t }}</button>
    </div>
    <div class="card">
      <div class="card-body" v-if="customer">
        <div class="row">
          <div class="col-2"></div>
          <div class="col-8">
            <div class="form-group">
              <label>{{ 'Payment for' | t }}</label>
              <input class="form-control" disabled="true" v-model="customer.name" />
            </div>
            <div class="form-group">
              <label>{{ 'currency' | t }}</label>
              <input class="form-control" disabled="true" v-model="customer.currency" />
            </div>
            <div class="form-group">
              <label>{{ 'invoice_type' | t }}</label>
              <select class="form-control" v-model="payment.doc_type">
                <option value="payment">{{ 'payment' | t }}</option>
                <option value="refund">{{ 'refund' | t }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>{{ 'select_invoice' | t }}</label>
              <select class="form-control" v-model="payment.invoice">
                <option :value="null">{{ 'No association' }}</option>
                <option v-for="invoice in suitable_invoices" :value="invoice">
                  {{ 'Id.' }} {{ invoice.id }} {{ ', No.' }} {{ invoice.invoice_no }}, {{ ', Sub Total.' }}
                  {{ invoice.sub_total_amount }} {{ invoice.currency }} {{ ', Total Amount.' }}
                  {{ invoice.total_amount }} {{ invoice.currency }} {{ ', Date.' }} {{ invoice.created_at | datetime }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>{{ 'amount' | t }}</label>
              <input class="form-control" v-model="payment.amount" />
            </div>
            <div class="form-group">
              <label>{{ 'payment_source' | t }}</label>
              <select class="form-control" v-model="payment.payment_source">
                <option value="bank">{{ 'bank' | t }}</option>
                <option value="credit_card">{{ 'credit_card' | t }}</option>
                <option value="balance" v-if="payment.doc_type != 'refund'">{{ 'balance' | t }}</option>
              </select>
            </div>
            <div class="form-group" v-if="payment.payment_source == 'bank'">
              <label>{{ 'payment_date' | t }}</label>
              <datetime-picker class="form-control" disabled="true" v-model="payment.payment_date"></datetime-picker>
            </div>
            <div class="form-inline">
              <checkbox v-model="payment.omit_accounting_sync"></checkbox>
              <label class="text-danger">{{ 'omit_accounting_sync' | t }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
import _ from 'lodash';
import Alerts from '@/utils/alerts.js';

export default {
  props: ['customer_id'],
  data: function () {
    return {
      customer: null,
      loading: false,
      invoice_search: '',
      loading_invoices: false,
      invoices: [],
      plans: [],
      payment: {
        customer: { id: this.customer_id },
        doc_type: 'payment',
        invoice: null,
        payment_source: 'bank',
        payment_date: null,
        omit_accounting_sync: false
      }
    };
  },
  watch: {
    'payment.invoice': function () {
      if (this.payment.invoice) {
        this.payment.amount = this.payment.invoice.total_amount;
      }
    }
  },
  computed: {
    suitable_invoices() {
      let invoices = this.invoices;
      let dtype = this.payment.doc_type;
      if (this.payment.doc_type == 'refund') {
        return _.filter(this.invoices, (i) => {
          return i.payment_status == 'unpaid' && i.doc_type == 'credit_memo';
        });
      } else {
        return _.filter(this.invoices, (i) => {
          return i.payment_status == 'unpaid' && i.doc_type == 'invoice';
        });
      }
    }
  },
  methods: {
    async load_invoices() {
      let { data: invoices } = await Api.findAll('invoices', {
        filter: { customer_id: this.customer_id },
        sort: '-created_at'
      });
      this.invoices = invoices;
    },
    async create() {
      Api.create('payments', this.payment)
        .then(() => {
          Alerts.success({ title: 'Success', detail: 'Payment created' });
          this.$router.push({
            name: 'customers_show',
            params: { customer_id: this.customer_id }
          });
        })
        .catch(({ errors }) => {
          Alerts.danger({ title: errors[0].title, detail: errors[0].detail });
        });
    }
  },
  mounted: async function () {
    let { data: customer } = await Api.find('customers', this.customer_id);
    this.customer = customer;
    this.payment.currency = customer.currency;
    this.load_invoices();
    this.setBreadcrumbs([
      { to: { name: 'customers' }, text: 'Customers' },
      {
        to: { name: 'customers_show', customer_id: this.customer_id },
        text: this.customer.name
      },
      { to: {}, text: 'New payment' }
    ]);
  }
};
</script>

<style scoped></style>
